// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nRSi","top":"styles_top__30LMZ","left":"styles_left__2xtyr","description":"styles_description__30hFH"};